import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cloud-up.icon",
  "use": "cloud-up.icon-usage",
  "viewBox": "-130.933 -11427.692 54.933 33.826",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-130.933 -11427.692 54.933 33.826\" id=\"cloud-up.icon\"><path data-name=\"Publish Icon-01\" d=\"M76.192,82.222a10.048,10.048,0,0,0-1.175.069,16.94,16.94,0,0,0-33.3-3.364c-.3-.023-.6-.046-.9-.046a10.622,10.622,0,1,0,0,21.245H52.344v-8.2H47.021c-1.336,0-2.028-1.866-1.06-2.949L56.583,76.83a1.4,1.4,0,0,1,2.143,0L69.349,88.974c.945,1.083.276,2.949-1.06,2.949H62.966v8.2h13.2a8.952,8.952,0,0,0,.023-17.9Z\" transform=\"translate(-161.133 -11493.992)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cloud-up.icon.svg
// module id = qg2a
// module chunks = 13